import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PrivateRoute from './services/PrivateRoute'
import Companies from './pages/Companies'
import sysAdminUsers from './pages/Users/sysAdminUsers'
import customerAdminUsers from './pages/Users/customerAdminUsers'
import SysAdminAddEditUser from './pages/Users/sysAdminUsers/AddEditUsers'
import CustomerAdminAddEditUser from './pages/Users/customerAdminUsers/AddEditUsers'
import NoMatch from './pages/Errors/404'
import NotAuthorized from './pages/Errors/NotAuthorized'
import userProfile from './pages/userProfile'
import Login from './pages/Login'
import ResetPassword from './pages/ResetPassword'
import ForgetPassword from './pages/ForgetPassword'
import AppRoutes from './services/AppRoutes'
import PublicAuthRoute from './services/PublicAuthRoute'
import Landing from './pages/Landing'
import FirstTimePassword from './pages/FirstTimePassword'
import UsersBatchActionsStatus from './pages/UsersBatchActionsStatus'
import ActionStatusDetails from './pages/UserBatchActionStatusDetail'
import NotificationInbox from './pages/Notification/NotificationInbox'
import ActionHistory from './pages/Notification/ActionHistory'
import NotificationCenter from './pages/Notification/NotificationCenter'
import AllRollsPublicAuthRoute from './services/AllRollsPublicAuthRoute'
import AccessDenied from './pages/Errors/403'

const Routes = () => (
  <Switch>
    <Route exact path={AppRoutes.notAuthorized} component={NotAuthorized} />
    <Route exact path={AppRoutes.accessDenied} component={AccessDenied} />
    <PublicAuthRoute exact path={AppRoutes.login} component={Login} />
    <Route exact path={AppRoutes.forgotPassword} component={ForgetPassword} />
    <Route exact path={AppRoutes.resetPassword} component={ResetPassword} />

    <PrivateRoute
      exact
      path={AppRoutes.userProfile}
      sysAdminComponent={userProfile}
      csAdminComponent={userProfile}
    />

    <PrivateRoute
      exact
      path={AppRoutes.home}
      sysAdminComponent={Companies}
      csAdminComponent={customerAdminUsers}
    />

    <PrivateRoute
      exact
      path={AppRoutes.adduser}
      sysAdminComponent={SysAdminAddEditUser}
      csAdminComponent={CustomerAdminAddEditUser}
    />
    <PrivateRoute
      exact
      path={AppRoutes.editUser}
      sysAdminComponent={SysAdminAddEditUser}
      csAdminComponent={CustomerAdminAddEditUser}
    />

    <PrivateRoute exact path={AppRoutes.users} sysAdminComponent={sysAdminUsers} />

    <PrivateRoute exact path={AppRoutes.usersBatchActionsStatus}
      csAdminComponent={UsersBatchActionsStatus} />

    <PrivateRoute
      path={AppRoutes.actionStatusDetails}
      csAdminComponent={ActionStatusDetails} />

    <Route path={AppRoutes.firstTimePassword} component={FirstTimePassword} />
    <Route path={AppRoutes.landing} component={Landing} />

    <AllRollsPublicAuthRoute
     exact path={AppRoutes.notificationCenter} component={NotificationCenter} />
    <AllRollsPublicAuthRoute
     exact path={AppRoutes.NotificationInbox} component={NotificationInbox} />
    <AllRollsPublicAuthRoute exact path={AppRoutes.ActionHistory} component={ActionHistory} />

    <Route path='*' component={NoMatch} />
  </Switch>
)

export default Routes
